'use client';

import type { ReactNode } from 'react';
import { Tag01Icon } from '@terra/ui-icons';
import { Box, VStack } from '@terra/ui-styled-system';
import { Badge } from '../../../../../components/badge';
import { MarkdownPreview } from '../../../../markdown-preview';
import type { HITLContentContext } from '../../tool-config-types';
import type { MemoryData } from './types';
import { MEMORY_CATEGORY_LABELS } from './types';

type MemoryCardProps = {
  memory: MemoryData;
};
const MemoryCard = ({ memory }: MemoryCardProps) => {
  const categoryLabel = memory.category
    ? MEMORY_CATEGORY_LABELS[memory.category]
    : undefined;

  return (
    <VStack gap={1.5} alignItems="flex-start" width="100%">
      {categoryLabel && (
        <Badge variant="outline" size="sm" icon={<Tag01Icon size={10} />}>
          {categoryLabel}
        </Badge>
      )}
      <Box
        bg="bg.canvas"
        p={2}
        borderRadius="sm"
        borderWidth="1px"
        borderColor="border.subtle"
        width="100%"
      >
        <MarkdownPreview source={memory.content} fontSize={12} compact />
      </Box>
    </VStack>
  );
};

export const renderMemoryContent = (ctx: HITLContentContext): ReactNode => {
  const memories = ctx.extractedData as MemoryData[];

  if (!memories || memories.length === 0) return null;

  return (
    <VStack
      gap={3}
      alignItems="stretch"
      width="100%"
      maxHeight={ctx.maxHeight}
      overflow="auto"
    >
      {memories.map((memory, index) => (
        <MemoryCard key={index} memory={memory} />
      ))}
    </VStack>
  );
};
